import { WithChildren } from '../types/utility';
import { DoubleSpinner } from './Spinner';
import styles from '../assets/css/spinner.module.css';
//@ts-ignore
import klarna_logo from '../assets/images/klarna_logo.png';
import { selectPrimaryColor } from '../app/slices/configuration.slice';
import { useAppSelector } from '../app/hooks';
import PentagramLogo from './svgs/PentagramLogo';
import TextCustomization from './customizations/TextCustomization';

interface LoadingSpinnerProps extends WithChildren {
	title?: string | JSX.Element;
	texts?: Array<string | JSX.Element>;
}

export const LoadingSpinner = ({ children, texts, title }: LoadingSpinnerProps) => {
	const hasContent = !!texts || !!title;

	return (
		<div className={styles['main-content']} id="spinner-container" style={{ width: '100%' }}>
			<div className={styles['equal-width-height-container']} id="spinner" style={{ position: 'relative' }}>
				<DoubleSpinner></DoubleSpinner>
			</div>
			<div className={`${styles['equal-width-height-container']}`} style={{ position: 'absolute' }}>
				{/* This div mocks/replaces spinner that is absolute  */}
				<div className={styles['spinner-relative-content']}>{children}</div>
			</div>

			{hasContent && (
				<div className={styles['main-content-text']}>
					{title && (
						<div className={styles['main-content-header']}>
							<span>
								<TextCustomization content={title} />
							</span>
						</div>
					)}
					{/* Safe to use index as key because texts array will not change dynamically */}
					{texts &&
						texts.map((text, index) => (
							<div className={styles['main-content-text']} key={index}>
								{text}
							</div>
						))}
				</div>
			)}
		</div>
	);
};

export const FincredibleLogo = () => {
	const primaryColor = useAppSelector(selectPrimaryColor) as string;
	return (
		<>
			<PentagramLogo fill={primaryColor} />
		</>
	);
};
